'use client';
export default  function getCurrentUser () {
    if (typeof window === "undefined") {
        return {};
    }
    const user = {};
    const token = typeof window !== "undefined" && localStorage.getItem("access_token");
    const userStr = typeof window !== "undefined" && localStorage.getItem("user");

    if (userStr) {
        user.user = JSON.parse(userStr);
    }
    if (token) {
        user.token = token;
    }
    return user;
};
